const types = {
  SET_PANEL_INFO: 'SET_PANEL_INFO',
  SET_SHOW_CREATE_PANEL: 'SET_SHOW_CREATE_PANEL',
  SET_SHOW_EDIT_PANEL: 'SET_SHOW_EDIT_PANEL',
  SET_PANEL: 'SET_PANEL',
  SET_CARD_PANEL: 'SET_CARD_PANEL',
  SET_PANEL_ID: 'SET_PANEL_ID',
};

export default types;



// WEBPACK FOOTER //
// ./src/store/modules/panels/mutations-types.js